<template>
  <div class="monthlyVideos">
    <a-card title="Create Your Own!" class="style3">
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1">
          <img src="https://s3.amazonaws.com/blog_thumbnails/jim-blog.png" />
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <p></p>
          <p></p>
          <h2>
            <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Intro.mp4">Intro Bumper</a>
          </h2>

          <br />
          <br />

          <h2>
            <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(he).mp4">If he can do it, you can to! Bumper</a>
          </h2>

          <br />
          <br />

          <h2>
            <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(they).mp4">If they can do it, you can to! Bumper</a>
          </h2>

          <br />
          <br />

          <h2>
            <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(she).mp4">If she can do, you can to! Bumper</a>
          </h2>

          <p></p>
          <p>
            <br />
          </p>
          <h1>Custom Monthly Encouragement Video Instructions</h1>
          <p>
            We are excited to offer your church the opportunity to create your very own monthly videos for Ingredient 5. First download the introduction video. Based off of who you are filming
            download the appropriate ending. Use Imovie or another basic video editing software, put your film between the introduction and ending. Double check your audio and then export your movie!
          </p>
          <p>
            <strong>
              Step 1:
              <span class="m_-674439508133141566gmail-Apple-converted-space">&nbsp;</span> </strong
            >Download the Introduction video
            <span class="m_-674439508133141566gmail-Apple-converted-space">&nbsp;</span>
            <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Intro.mp4" download="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Intro.mp4">here</a>.
          </p>
          <p>
            <strong>
              Step 2:
              <span class="m_-674439508133141566gmail-Apple-converted-space">&nbsp;</span> </strong
            >Download a matching ending.
          </p>
          <ul>
            <li>
              <p>
                Download the "He can do it ending"
                <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(he).mp4" download="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(he).mp4">here.</a>
              </p>
            </li>
            <li>
              <p>
                Download the "She can do it bumper"
                <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(she).mp4" download="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(she).mp4">here.</a>
              </p>
            </li>
            <li>
              <p>
                Download the "They can do it bumper
                <span class="m_-674439508133141566gmail-Apple-converted-space">"</span>
                <a href="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(they).mp4" download="https://truelifeorg.s3.amazonaws.com/Bumper+Videos/Bumper+Outro+(they).mp4">
                  here
                  <strong>.</strong>
                </a>
              </p>
            </li>
          </ul>
          <p>NOTE: If you have trouble downloading the videos please right-click and choose save-as.</p>
          <p></p>
        </div>
      </div>
    </a-card>
    <a-card v-for="page in pages" :title="page.title" class="style3" :key="page.id">
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1">
          <img :src="page.icon_img" />
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <p>
            <button type="button" class="btn btn-warning btn-lg">
              <a :href="page.download_video" style="color: #fff;">Download Video</a>
            </button>
            <button type="button" class="btn btn-info btn-lg" v-if="page.read_blog">
              <a :href="page.read_blog" style="color: #fff;">Read Blog</a>
            </button>
          </p>
          <p>
            <iframe :src="page.embed_video" webkitallowfullscreen mozallowfullscreen allowfullscreen width="579" height="326" frameborder="0"></iframe>
          </p>
          <p v-html="page.description"></p>
        </div>
      </div>
    </a-card>
  </div>
</template>
<script>
import PageService from '@/services/PageService';
export default {
  data: () => ({
    pages: [],
  }),
  async created() {
    this.pages = await PageService.getMonthlyPages();
  },
};
</script>
<style lang="scss">
.monthlyVideos {
  .btn-warning {
    margin-right: 10px;
  }
}
</style>
